'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  viewport: 'dedicated',
  config: {
    id: '',
    textAlign: 'left',
    theme: 'theme-background-image-dark',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business.jpg',
      portable: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-medium.jpg',
      mobile: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-small.jpg'
    },
    backgroundPosition: 'center',
    height: 'tall'
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize contrast with ' + 'background image. 152 characters maximum.'
    },
    mediaButton: {
      id: '',
      text: '25 characters maximum',
      'data-video-id': 'lkz4GZgyb9o'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    hatchText: {
      text: '34 characters maximum per line'
    },
    ribbon: {
      config: {
        theme: 'theme-background-color-dark'
      },
      img: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/merchant/logo/bib-logo-collapsed.png',
        alt: 'pp-credit'
      },
      text: '100 characters maximum.'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/overlay-hero/props/default.js
// module id = 1123
// module chunks = 4